<template>
  <v-container fluid>
    <div v-if="isCliente == 0">
      <section class="content-header">
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>Transmision Masiva de Guias (Tramaco, ServiEntrega)</v-toolbar-title>
        </v-toolbar>
      </section>
        <v-card elevation="24" outlined>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <v-card height="100%" elevation="24" outlined shaped>
                    <v-card-title>Agregar guias separadas por coma(,)</v-card-title>
                    <v-card-text>
                      <v-textarea
                      label="Ingrese guías separadas por coma (,)"
                      v-model="guiasComa"
                      prepend-icon="mdi-file-multiple"
                      @keyup.enter="addComa"></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small outlined color="primary" @click="addGuiasporComas()">Agregar <v-icon dark>mdi-arrow-right</v-icon></v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-card height="100%" elevation="24" outlined shaped>
                    <v-card-title>Guias</v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="headers"
                        :items="guiasActualizar"
                        item-key="guia_hija"
                        class="elevation-3"
                        :items-per-page="15"
                      >
                        <template v-slot:item.acciones="{ item }">
                          <v-tooltip bottom color="#96298A">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                color="red"
                                @click="eliminarGuiaActualizar(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Eliminar</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="5">
                    <v-card height="100%" elevation="24" outlined shaped>
                        <v-card-title>Transmision</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <v-radio-group v-model="transmitirA" row>
                                <v-radio label="Tramaco" :value="1"></v-radio>
                                <v-radio label="ServiEntrega" :value="2"></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <enviar-tramaco v-if="transmitirA == 1" :guias="guiasActualizar" :mode="'CO'"></enviar-tramaco>
                              <enviar-servi-entrega v-if="transmitirA == 2" :guias="guiasActualizar" :mode="'CO'"></enviar-servi-entrega>
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
    </div>
    <div v-else>
      <h1>Usted no tiene permisos para ver esta sección</h1>
    </div>
  </v-container>
</template>
<script>
import apicon from "../plugins/apicon";
import Waiting from "../components/Waiting.vue";
import EnviarTramaco from '../components/EnviarTramaco.vue';
import EnviarServiEntrega from '../components/EnviarServiEntrega.vue';
export default {
  components: {
    Waiting,
    EnviarTramaco,
    EnviarServiEntrega,
  },
  created: function () {},
  data() {
    return {
      overlay: false,
      fullScreen: true,
      valid: true,
      guiasActualizar: [],
      guiasComa: null,
      guiasLst: [],
      headers: [
        { text: "Guia", value: "guia_hija" },
        { text: "Acciones", value: "acciones", align: "end", sortable: false },
      ],
      /*Variables*/
      fecha: null,
      hora: null,
      comentarios: null,
      /*Variables*/
      isCliente: 1,
      lstEstatus: [],
      estatus: null,
      transmitirA: 1
    };
  },
  methods: {
    addComa: function(e){
        if (e.keyCode == '13') { e.preventDefault(); }
        this.guiasComa += ',';
        this.guiasComa = this.guiasComa.replace("\n","");
      },
    //Agregar guia a lista
    addGuiasporComas: function(){
            let guias = this.guiasComa.split(',');
            guias.forEach(guia => {
                if(guia != null && guia != ''){
                    this.guiasActualizar.push({guia_hija : guia});
                }
            });
            this.guiasComa = null;
        },
        eliminarGuiaActualizar: function(item){
            this.guiasActualizar.splice(this.guiasActualizar.findIndex((p) => p === item), 1);
        },
  },
  mounted() {
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>
